import React, { useEffect } from 'react';

import { scrollToTop } from '../../_helpers/useful-functions';

let scrollElement: any = document.getElementById('root');

const ArrowHead = () => {
    const isHome = scrollElement?.classList?.contains('home');
    useEffect(() => {
        if (isHome) {
            scrollElement = window;
        }
        scrollElement.addEventListener('scroll', onScrolling);
    }, [isHome]);

    const onScrolling = () => {
        const targetContent = document?.getElementById('the-news-content');
        const targetContentTop = targetContent?.getBoundingClientRect().top;
        const targetElement = document?.getElementById('arrow-head');

        if (targetElement) {
            if (targetContentTop <= 0) {
                targetElement.style.display = 'block';
            } else {
                targetElement.style.display = 'none';
            }
        }
    };

    return (
        <div className="c-arrow-item">
            <a href="#!" onClick={() => scrollToTop('smooth')} className="c-icon-arrow" id="arrow-head">
                <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M38.5 52C38.5 52.8284 39.1716 53.5 40 53.5C40.8284 53.5 41.5 52.8284 41.5 52L38.5 52ZM41.0607 25.9393C40.4749 25.3536 39.5251 25.3536 38.9393 25.9393L29.3934 35.4853C28.8076 36.0711 28.8076 37.0208 29.3934 37.6066C29.9792 38.1924 30.9289 38.1924 31.5147 37.6066L40 29.1213L48.4853 37.6066C49.0711 38.1924 50.0208 38.1924 50.6066 37.6066C51.1924 37.0208 51.1924 36.0711 50.6066 35.4853L41.0607 25.9393ZM41.5 52L41.5 27L38.5 27L38.5 52L41.5 52Z"
                        fill="white"
                    />
                </svg>
            </a>
        </div>
    );
};

export default ArrowHead;
